// extracted by mini-css-extract-plugin
export default {"container":"LayoutNew_container__L8ogu","sub_container":"LayoutNew_sub_container__XiTNa"};